export function doesStartWithVowel(text: string): boolean {
  return "aeiou".indexOf(text.charAt(0).toLowerCase()) >= 0;
}

export function capitalizeFirstLetter(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function trimAndEllipsify(text: string, noOfChars: number): string {
  return text.length > noOfChars ? `${text.substr(0, noOfChars)}...` : text;
}

/**
 * SECURITY: This output is injected via `dangerouslySetInnerHTML` in HubActivity.
 * The regex does NOT escape user input — links inside text bodies are vulnerable
 * to XSS via crafted `href` payloads. Migrate consumers to a sanitizer (e.g. DOMPurify)
 * before calling, OR rewrite this to render as React elements.
 * Tracked separately — do not "fix" as part of the functions.jsx split.
 */
export function convertTextLinksToHyperLinks(text: string): string {
  const exp =
    /(\b(https?|http|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  const text1 = text.replace(exp, '<a target="_blank" href=$1>$1</a>');
  const exp2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

export function convertNumberToNumberWord(n: number): string | undefined {
  switch (n) {
    case 0: return "zero";
    case 1: return "one";
    case 2: return "two";
    case 3: return "three";
    case 4: return "four";
    case 5: return "five";
    case 6: return "six";
    case 7: return "seven";
    case 8: return "eight";
    case 9: return "nine";
    case 10: return "ten";
    case 11: return "eleven";
    case 12: return "twelve";
    case 13: return "thirteen";
    case 14: return "fourteen";
    case 15: return "fifteen";
    case 16: return "sixteen";
    case 17: return "seventeen";
    case 18: return "eighteen";
    case 19: return "nineteen";
    case 20: return "twenty";
    case 30: return "thirty";
    case 40: return "fourty";
    case 50: return "fifty";
    case 60: return "sixty";
    case 70: return "seventy";
    case 80: return "eighty";
    case 90: return "ninty";
    case 100: return "hundred";
    default: return undefined;
  }
}

export function getLanguageLabel(languageCode: string): string {
  switch (languageCode) {
    case "ESP": return "Español";
    case "ENG": return "English";
    default: return "English";
  }
}

export function percentage(part: number | string, total: number | string): number {
  return Math.ceil(
    (parseInt(String(part), 10) * 100) / parseInt(String(total), 10)
  );
}
